declare var $: any;

export const HelperFunctions = {
    loadScript(src, callback) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = src;
        if ($('[url="' + src + '"]').length > 0) {
            callback()
            return true;
        }
        var x = document.body.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
        s.addEventListener('load', function (e) {
            callback()
        }, false);
    },
    ifExists(element, callback) {
        if ($(element).length > 0) {
            callback()
            return true;
        }
        return null;
    },
    formatPrice(num) {
        var str = num.toString().replace(/[^\d]/g, ""),
            parts = false,
            output = [],
            i = 1,
            formatted = null;
        if (str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for (var j = 0, len = str.length; j < len; j++) {
            if (str[j] != ",") {
                output.push(str[j]);
                if (i % 3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("")
        return (formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
    },
    validateEmail(email) {
        var re =
            /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    },
    maxChars(input, num) {
        var count = $(input).val().split('').length;
        if ($(input).attr('name') === 'browserTitle') {
            var originalNum = num;
            num = originalNum - $(input).attr('chars-substract').split('').length;
            $('[name="addSiteName"]').on('change', function () {
                if ($('[name="addSiteName"]:checked').attr('checked')) {
                    $('[name="browserTitle"]').attr('chars-substract', $('[name="addSiteName"]').attr('to-substract'))
                } else {
                    $('[name="browserTitle"]').attr('chars-substract', '')
                }
                num = originalNum - $(input).attr('chars-substract').split('').length;
                doCheck();
            })
        }
        var doCheck = function () {
            count = $(input).val().split('').length
            $(input).parents('.field').attr('charCount', count + '/' + num);
            if (num < count) {
                $(input).parents('.field').addClass('error');
            } else {
                $(input).parents('.field').removeClass('error');
            }
        };
        doCheck();
        // on keyup event
        $(input).on('keyup', function () {
            doCheck();
        })
    },
    minChars(input, num) {
        var count = $(input).val().split('').length;
        if ($(input).attr('name') === 'browserTitle') {
            var originalNum = num;
            num = originalNum - $(input).attr('chars-substract').split('').length;
            $('[name="addSiteName"]').on('change', function () {
                if ($('[name="addSiteName"]:checked').attr('checked')) {
                    $('[name="browserTitle"]').attr('chars-substract', $(
                        '[name="addSiteName"]').attr('to-substract'))
                } else {
                    $('[name="browserTitle"]').attr('chars-substract', '')
                }
                num = originalNum - $(input).attr('chars-substract').split('').length;
                doCheck();
            })
        }
        var doCheck = function () {
            count = $(input).val().split('').length
            $(input).parents('.field').attr('charCount', count + '/' + num);
            if (num > count) {
                $(input).parents('.field').addClass('error');
            } else {
                $(input).parents('.field').removeClass('error');
            }
        };
        doCheck();
        // on keyup event
        $(input).on('keyup', function () {
            doCheck();
        })
    }
}


// WEBPACK FOOTER //
// ./src/script/helpers/dom.helper.ts